<template>
  <div class="floating-input-label">
    <select
      :class="[currentValue !== '' ? 'filled' : '', 'form-element floating-input-label__select']"
      :id="id ? id : _uid"
      v-model="currentValue"
      @change="handleChange"
    >
      <option v-if="!mandatory" value="" selected="selected"></option>
      <option
        v-for="option in options"
        v-bind:key="option.value"
        :value="option.value"
      >{{ option.label }}</option>
    </select>
    <label class="floating-input-label__label" :for="_uid">{{ label }}</label>
  </div>
</template>

<script>
export default {
  data: () => ({
    currentValue: '',
  }),
  props: {
    label: String,
    id: String,
    options: Array,
    mandatory: {
      type: Boolean,
      default: false,
    },
    value: String,
  },
  methods: {
    handleChange() {
      this.$emit('input', this.currentValue);
    },
  },
  created() {
    this.currentValue = this.value ?? '';
  },
};
</script>
